/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import CalendarLocale from '../calendar/ar_EG';
import TimePickerLocale from '../time-picker/ar_EG';

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'Ø§Ø®ØªÙØ§Ø± Ø§ÙØªØ§Ø±ÙØ®',
    rangePlaceholder: ['Ø§ÙØ¨Ø¯Ø§ÙØ©', 'Ø§ÙÙÙØ§ÙØ©'],
    ...CalendarLocale
  },
  timePickerLocale: {
    ...TimePickerLocale
  },
  dateFormat: 'DD-MM-YYYY',
  monthFormat: 'MM-YYYY',
  dateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
  weekFormat: 'wo-YYYY'
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;
